// src/services/userService.js
import Config from '../components/Common_Files/Config';

const API_BASE_URL = Config.api_url + '/';

export const fetchUsers = async (draw, start, length) => {
  const accessToken = localStorage.getItem('accessToken');
  
  // Check if accessToken is missing and redirect to login page if necessary
  if (accessToken === null) {
    window.location.href = '/login'; // Adjust the URL to your login page
    return;
  }

  // Create FormData object
  const formData = new FormData();
  formData.append('draw', draw);
  formData.append('start', start);
  formData.append('length', length);

  const apiUrl = `${API_BASE_URL}ws-get-user-list`;

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`, // Correct capitalization
        // Do not set Content-Type for FormData; fetch will handle it
      },
      body: formData,
    });

    if (response.status === 401) {
      // Redirect to login page if unauthorized
      window.location.href = '/login'; // Adjust the URL to your login page
      return;
    }

    if (!response.ok) {
      throw new Error('Failed to fetch user data');
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};


export const addUser = async (userData) => {
  const apiUrl = `${API_BASE_URL}ws-add-user`;

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: `Bearer ebu`,
      },
      body: JSON.stringify(userData),
    });

    if (!response.ok) {
      throw new Error('Failed to add new user');
    }

    return response.json();
  } catch (error) {
    console.error('Error adding new user:', error);
    throw error;
  }
};
